import React from 'react';
import { useFormContext } from 'react-hook-form';

const Step4Property: React.FC = () => {
  const { register, formState: { errors } } = useFormContext();

  return (
    <div className="solar-form-grid">
      <div>
        <label htmlFor="propertyType" className="solar-form-label">
          Property Type
        </label>
        <select
          id="propertyType"
          {...register('propertyType')}
          className="solar-form-select"
        >
          <option value="">Select property type</option>
          <option value="residential">Residential</option>
          <option value="commercial">Commercial</option>
          <option value="industrial">Industrial</option>
        </select>
        {errors.propertyType && (
          <p className="solar-form-error">{String(errors.propertyType.message)}</p>
        )}
      </div>

      <div>
        <label htmlFor="propertyOwnership" className="solar-form-label">
          Property Ownership
        </label>
        <select
          id="propertyOwnership"
          {...register('propertyOwnership')}
          className="solar-form-select"
        >
          <option value="">Select ownership type</option>
          <option value="owned">Owned</option>
          <option value="rented">Rented</option>
        </select>
        {errors.propertyOwnership && (
          <p className="solar-form-error">{String(errors.propertyOwnership.message)}</p>
        )}
      </div>
    </div>
  );
};

export default Step4Property; 